const isBrowser = typeof window !== 'undefined';

export function useRenderGuard(isOpen: boolean): boolean {
  // Gatsby renders during SSR; Eva relies on browser APIs, so avoid rendering until in-browser.
  return isBrowser && isOpen;
}

